<template>
	<div class="main-contents">
		<div class="faq_wrap">
			<div class="title_wrap">
				<h2>이용안내</h2>
			</div>
			<div class="tab_wrap flex">
				<div class="tab" style="width: 200px;">
					<ul style="flex-direction: column;">
						<li v-for="(item, index) in faqTabList" :key="index" :class="tabIdx == index ? 'active' : ''">
							<a @click="tabIdxCng(index)">
								<span>{{item}}</span>
							</a>
						</li>
					</ul>
				</div>

				<div class="tab_cont_group" style="width: 1000px;">
					<!--서비스 소개-->
					<div class="tab_cont" :class="tabIdx == '0' ? 'active' : ''">
						<div class="tab_cont_inner">
							<div class="ta-left mb-4">
								<strong class="text_type_title">그레이트 프로는 어떤 플랫폼인가요?</strong>
							</div>
							<p class="text_type_01 ta-left mb-16">
								그레이트 프로는 <span class="faqBold">대한민국 최초 금융 IT 얼라인먼트 플랫폼</span>입니다.<br />
                                검증된 IT 전문인재와 <span class="faqBold">금융권 프로젝트와 연결시키며 성공적인 프로젝트 수행을 지원</span>합니다.<br />
                                단순한 인력 매칭을 넘어서 IT 전문가와 기업이 함께 성장하는 신뢰 기반 생태계를 구축하며, 기업에게는 믿음직한 파트너를, IT 전문가에게는<br />든든한 동반자 역할을 합니다.<br />
                                <span class="faqBold">전문성, 신뢰, 보증, 존경</span>이라는 4대 핵심 가치를 바탕으로, 빠른 연결보다는 정확한 얼라인먼트를, 많은 프로젝트보다 신뢰할 수 있는 프로젝트를 추구하여 <span class="faqBold">모두가 성장하고 성공하는 생태계</span>를 만들어갑니다.<br />
							</p>

							<div class="ta-left mb-4">
								<strong class="text_type_title">그레이트프로는 다른 인재 매칭 플랫폼과 무엇이 다른가요?</strong>
							</div>
							<p class="text_type_01 ta-left mb-16">
								그레이트프로만의 차별화된 특징은 다음과 같습니다.<br />
								<span class="faqBold">1. 전문가 중심의 정밀 매칭:</span> 20년 이상 경력의 전문 매니저가 직접 인재를 선별하고 프로젝트에 최적화된 얼라인먼트를 제공합니다.<br />
								<span class="faqBold">2. 업계 유일 성공 보상금 제도:</span> 프로젝트 완수 시 추가 보상금을 지급하여 IT 전문가들이 더욱 책임감 있게 프로젝트에 임할 수 있도록 동기를<br /><nbsp n="4"/>부여합니다.<br />
								<span class="faqBold">3. 금융 IT 전문성:</span> 11년 이상 축적된 금융권 도메인 전문성과 검증된 인재 풀을 바탕으로 정확한 매칭을 보장합니다.<br />
								<span class="faqBold">4. 통합 성장 지원:</span> 단순 프로젝트 연결을 넘어 세무, 법무, 커리어 관리까지 IT 전문가의 성장을 종합적으로 지원합니다.<br />
							</p>

							<div class="ta-left mb-4">
								<strong class="text_type_title">그레이트프로는 프로젝트의 품질을 어떻게 보장하나요?</strong>
							</div>
							<p class="text_type_01 ta-left mb-16">
								그레이트프로는 11년간 분쟁률 0%의 검증된 운영 실적을 바탕으로 안정적인 프로젝트 수행을 지원합니다.<br />
								<span class="faqBold">1. 검증된 직계약 시스템:</span> 그레이트프로가 모든 계약의 1차 당사자가 되어 기업 고객에게는 단일 창구 서비스를 제공하고, 계약 당사자로서<br /><nbsp n="4"/>프로젝트 전 과정을 책임감 있게 관리하여 문제 발생 시 신속한 해결 방안을 제시합니다.<br />
								<span class="faqBold">2. 4단계 검증 시스템:</span> 모든 IT 전문가는 경력의 정량 평가, 전담 매니저의 정밀 진단, 프로젝트 수행 중 다면 평가, 우수 성과자 대상 스페셜 등급<br /><nbsp n="4"/>부여의 엄격한 검증 과정을 거쳐 선별됩니다.<br />
								<span class="faqBold">3. 전담 관리 체계:</span> 프로젝트별로 배정된 전담 PM이 착수부터 완료까지 전 과정을 관리하며, 정기적인 진행 상황 점검과 선제적 이슈 대응을 통해<br /><nbsp n="4"/>프로젝트의 성공적 완수를 지원합니다.<br />
							</p>					
						</div>
					</div>
					<!-- 수요기업 -->
					<div class="tab_cont" :class="tabIdx == '2' ? 'active' : ''">
						<div class="tab_cont_inner">
							<div class="cont_nav">
								<ul class="cont_nav_list">
									<li v-for="(item, index) in dcoItemList" :key="index" :class="itemIdx == index ? 'active' : ''">
										<a @click="itemIdxCng(index)">{{item}}</a>
									</li>
								</ul>
							</div>							

							<!--01 회원가입 -->
							<div class="cont_detail pl-10" v-if="itemIdx == '0'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">그레이트프로에서 클라이언트란?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									클라이언트는 IT프로로부터 용역을 제공받거나 용역제공을 위하여 IT프로를 모집하는 기업을 의미합니다. 직접 IT프로로부터 용역을 제공받는 발주사 또는 프로젝트를 수주한 사업자 모두 클라이언트에 해당됩니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">클라이언트 회원가입은 어떻게 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									클라이언트 회원가입은 두 단계로 진행됩니다.<br />
									먼저 그레이트프로와 서비스 이용계약을 체결하여 기업 정보를 등록한 후, 해당 기업의 실무담당자가 개인 명의로 회원가입을 진행하게 됩니다.<br />
									<br />
									서비스 이용계약 체결 시 제공된 기업 정보를 그레이트프로 운영팀에서 시스템에 등록하며, 이후 기업당 1개 계정을 원칙으로 하여 실무담당자가 회원으로 가입할 수 있는 환경이 구축됩니다.<br />
									<br />
									회원가입 후에는 검증된 IT프로 풀에 접근하여 프로젝트에 최적화된 인재를 찾아보실 수 있으며, 전담 매니저의 지원을 받아 원활한 프로젝트 매칭과 관리 서비스를 이용하실 수 있습니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">서비스 이용료는 어떻게 되나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									그레이트프로는 구독료 모델을 운영합니다. 현재는 서비스 안정화를 위해 무료로 제공하고 있으며, 향후 정식 유료 서비스로 전환할 예정입니다.
								</p>
							</div>
							<!--//01 회원가입 -->

							<!--02 프로젝트 등록 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '1'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 등록은 어떻게 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									프로젝트 관리의 프로젝트 등록 메뉴에서 상세 정보를 입력하여 등록할 수 있습니다. 등록에 어려움이 있으면 담당 매니저에게 연락 주시면 등록을 도와드립니다.<br />
									프로젝트 등록 완료 후 그레이트프로 전담 매니저가 연락드려 등록 내용 검토 및 매칭 프로세스를 안내해드립니다. 전담 매니저가 프로젝트 요구사항을 정밀 분석하여 최적의 IT프로 매칭을 지원합니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">그레이트 프로 매니저는 누구이며, 어떤 도움을 줄 수 있나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									프로젝트 등록 시 금융 IT 전문 매니저가 선임되어 프로젝트 전 과정을 지원합니다. 등록 내용 검토부터 IT프로 선발, 인터뷰 진행, 계약, 프로젝트 관리, 종료 후 평가까지 체계적으로 관리하며, 프로젝트 수행 중 발생하는 이슈에 대해서도 신속한 지원을 제공합니다.<br />
									전담 매니저를 통해 검증된 IT프로 풀에서 프로젝트에 최적화된 인재를 추천받으실 수 있으며, 종합적인 행정사무 지원도 함께 받으실 수 있습니다.
								</p>
							</div>
							<!--//02 프로젝트 등록 -->

							<!--03 IT프로 찾기 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '2'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">IT프로 찾기 서비스는 무엇인가요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									프로젝트 수행에 필요한 검증된 IT 전문가를 검색하는 서비스입니다.<br />
									프로젝트를 등록한 클라이언트는 4단계 검증을 통과한 IT프로의 상세한 이력 정보와 평가 정보를 확인하여 프로젝트에 최적화된 인재를 선별할 수 있습니다.<br />
									프로젝트 인터뷰 요청과 '관심 IT프로 등록' 기능을 통해 즉시 매칭 프로세스를 진행할 수 있어 효율적인 인재 선발이 가능합니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">IT프로 정보는 어떤 내용을 확인할 수 있나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									클라이언트는 IT프로의 평가등급, 기술등급, 전문분야, 보유기술, 프로젝트 수행 이력 등 주요 정보를 확인할 수 있습니다. 또한 자기소개서, 학력, 경력사항, 클라이언트 평가 등 상세 정보도 제공됩니다.<br />
									<br />
									현재는 서비스 안정화를 위해 모든 정보를 무료로 제공하고 있으며, 향후 유료 서비스 전환 시에는 회원 구분에 따라 확인 가능한 정보 범위에 차등이 있을 예정입니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">IT프로 평가등급은 어떻게 결정되나요? </strong>
								</div>
								<p class="text_type_01 ta-left">
									IT프로의 평가등급은 클라이언트 평가와 그레이트프로 평가의 평균값으로 산정됩니다. 클라이언트 평가는 최근 5개 프로젝트의 평가 점수 평균이며, 그레이트프로 평가는 전체 활동 기간에 대한 내부 평가 결과입니다.<br />
									각 평가는 업무실적, 근무태도, 기술능력 등을 다각도로 평가하여 항목별로 점수를 부여하며, 이는 시각적인 평가표로 제시됩니다. 프로젝트 참여 기회가 없는 경우 미평가로 표시됩니다. 
								</p>
							</div>
							<!--//03 IT프로 찾기 -->

							<!--04 프로젝트 지원인재 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '3'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트에 지원한 IT프로는 어떻게 확인할 수 있나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									프로젝트에 지원한 IT프로 정보는 두 가지 경로로 확인할 수 있습니다. 프로젝트 관리 메뉴의 지원 IT프로 화면을 통해 직접 조회하거나, 마이페이지의 프로젝트 관리 현황 대시보드에서 프로젝트 지원 IT프로 항목을 통해 확인할 수 있습니다.<br />
									표시되는 지원자들은 그레이트프로에서 기본적인 적합성 판단을 거쳐 추천한 검증된 인재들입니다. 클라이언트는 사전 검증된 우수한 후보군만을 검토하여 선별 시간을 절약할 수 있으며, 프로젝트 요구사항에 적합한 인재를 선택하여 바로 인터뷰를 요청할 수 있습니다.
								</p>

							</div>
							<!--//04 프로젝트 지원인재 -->

							<!--05 관심인재 등록 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '4'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">관심인재란?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									관심인재는 프로젝트에 적합한 IT프로를 사전에 선별하여 저장하는 기능입니다.<br /><br />
									클라이언트는 IT프로 검색을 통해 프로젝트에 적합한 인재를 관심인재로 등록하고, 필요 시 일괄 조회하여 인터뷰를 요청할 수 있습니다.
									관심인재 등록은 인재 확보의 우선권을 의미하지 않으며, 해당 IT프로는 다른 기업의 프로젝트에도 참여할 수 있습니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">관심인재 등록 및 삭제는 어떻게 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									<strong>등록 방법</strong><br />
									1. IT프로 찾기 메뉴에서 적합한 인재 검색<br />
									2. IT프로 상세정보에서 '관심인재' 버튼 클릭<br />
									3. ''프로젝트 관리 > 내 IT프로 > 관심 IT프로' 메뉴에서 등록된 인재 확인<br /><br />

									<strong>삭제 방법</strong><br />
									관심인재 메뉴에서 삭제할 IT프로를 선택하여 일괄 삭제할 수 있습니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">관심인재로 등록하면 해당 IT프로에게 알림이 전송되나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									네, 관심인재로 등록되면 해당 IT프로에게 알림이 전송되며, IT프로는 자신을 관심인재로 등록한 기업을 확인할 수 있습니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">관심인재 등록 후 반드시 인터뷰를 진행해야 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									아니요, 관심인재 등록 후 인터뷰를 진행하지 않아도 IT프로에게 불이익은 없습니다.<br />
									관심인재 등록은 향후 프로젝트 진행 시 빠른 인재 선별을 위한 사전 준비 과정입니다.
								</p>
							</div>
							<!--//05 관심인재 등록 -->

							<!--06 IT프로 인터뷰 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '5'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">IT프로 정보는 어떻게 확인할 수 있나요? </strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									IT프로 정보는 다음과 같은 방법으로 확인하실 수 있습니다.<br /><br />

									<strong>1. 신규 인재 발굴:</strong> 'IT프로 찾기' 메뉴에서 검색 조건을 설정하여 적합한 IT프로를 검색하고 상세 정보를 확인할 수 있습니다.<br />
									<strong>2. 기존 프로젝트 참여 인재:</strong> '프로젝트 관리 > 내 IT프로 > 진행 인터뷰'의 메뉴에서 기존 프로젝트에 참여하거나 인터뷰를 진행한 IT프로 정보를 조회할 수 있습니다.<br />
									<strong>3. 평가 등급 안내:</strong> 그레이트 프로 평가등급은 자체 평가와 프로젝트 수행 평가를 종합하여 산정되므로, 프로젝트 참여 경험이 없는 경우 미평가로 표시됩니다.<br />
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">IT프로에게 인터뷰 요청은 어떻게 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									<strong>인터뷰 요청 절차</strong><br />
									1. IT프로 상세보기 화면에서 '인터뷰 요청' 선택<br />
									2. 인터뷰 대상 프로젝트 정보 입력 및 요청 제출<br />
									3. 그레이트 프로 전담 매니저가 요청 내용 검토 및 일정 조율<br />
									4. 그레이트 프로 매니저 주관하에 인터뷰 진행<br /><br />

									<strong>매니저 지원 서비스</strong><br />
									전담 매니저가 인터뷰 일정 조율부터 진행까지 전 과정을 지원하며, 프로젝트 관리 시스템을 통해 진행 상황을 체계적으로 관리합니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">다른 프로젝트에 참여 중인 IT프로에게도 인터뷰 요청이 가능한가요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									네, 가능합니다.<br />
									다만 진행 중인 프로젝트가 있는 경우 인터뷰 일정 및 프로젝트 전환 가능성을 고려하여 그레이트 프로 매니저와 사전 협의하시기 바랍니다.
									매니저가 해당 IT프로의 현재 프로젝트 담당 매니저와 협의하여 원활한 프로젝트 진행이 이루어지도록 조율합니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">인터뷰 결과 부적합 판정 시 어떻게 처리되나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									<strong>사전 검토 시스템</strong><br />
									그레이트 프로 전담 매니저가 인터뷰 요청 시 1차 사전 검토를 진행합니다. 해당 프로젝트에 부적합하다고 판단될 경우, 매니저가 '반려 및 교체 제안' 의견을 전달합니다.<br />
									
									<strong>선택권 보장</strong><br />
									최종 인터뷰 진행 여부는 클라이언트가 결정할 수 있으며, 교체 제안을 수용하거나 기존 계획대로 인터뷰를 진행할 수 있습니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">인터뷰 결과는 어떻게 공유되나요?</strong>
								</div>
								<p class="text_type_01 ta-left">
									클라이언트는 인터뷰 결과를 그레이트프로 전담 매니저에게 전달하시면 됩니다. 매니저가 프로젝트 관리 시스템에 결과를 등록한 후 해당 IT프로에게 안내해드립니다.
									인터뷰 결과는 체계적으로 기록되어 향후 프로젝트 매칭 시 참고 자료로 활용됩니다.
								</p>
							</div>
							<!--//06 IT프로 인터뷰 -->

							<!--07 계약 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '6'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 계약은 어떻게 진행하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									프로젝트의 참여 인재가 확정되면 클라이언트와 그레이트 프로 간에 직접 계약을 체결합니다.<br />
									그레이트 프로 전담 매니저가 계약서 작성부터 조건 협의까지 전 과정을 담당합니다. 별도의 온라인 계약 시스템은 제공하지 않으며, 매니저와의 직접 협의를 통해 계약 조건을 확정하고 체결합니다.<br />
									이러한 직계약 방식을 통해 클라이언트는 단일 창구로 계약 관계를 명확히 정리할 수 있으며, 프로젝트 진행 과정에서 발생할 수 있는 다양한 이슈에 대해 그레이트프로가 일원화된 지원을 제공합니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 수행 도중 계약을 변경해야 할 경우 어떻게 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									그레이트프로 전담 매니저와 협의하시면 됩니다.
									프로젝트 범위, 기간, 조건 등의 변경이 필요한 경우 매니저가 변경계약서 또는 추가계약서 등 적절한 조치 방법을 안내해드립니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">계약 및 대금 지급은 어떻게 처리되나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									모든 계약 업무는 그레이트 프로 본사에서 직접 처리하며, 필요시 프로젝트 전담 매니저에게 실무를 위임하여 진행합니다.
								</p>
							</div>
							<!--//07 계약 -->

							<!--08 프로젝트 진행관리 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '7'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 수행 중 어떤 지원을 받을 수 있나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									그레이트프로는 프로젝트의 성공적인 수행을 위해 다음과 같은 관리 지원을 제공합니다.<br /><br />

									<strong>프로젝트 안정성 확보 :</strong> 투입된 IT프로가 귀사의 업무 환경에 원활하게 적응할 수 있도록 사전 교육을 실시하며, 근무 규정과 보안 수칙 등을 철저히 안내합니다.<br /><br />

									<strong>지속적인 성과 관리 :</strong> 전담 매니저가 정기적으로 프로젝트 진행 상황을 모니터링하여 업무 수행 품질을 확인하고, 팀워크나 협업에 문제가 없는지 점검합니다.<br /><br />

									<strong>신속한 문제 해결 :</strong> 프로젝트 수행 과정에서 발생하는 모든 이슈에 대해 전담 매니저가 즉시 대응하며, 필요시 개선 방안이나 추가 조치를 신속하게 제공합니다.<br /><br />

									<strong>효과적인 지원을 위한 협력 :</strong> 그레이트 프로의 현장 지원 활동은 제한적이므로, 보다 효과적인 프로젝트 관리를 위해 클라이언트와 매니저 간의 적극적인 정보 공유 및 협력이 필요합니다. 프로젝트 진행 상황이나 이슈 사항을 신속히 공유해주시면 더욱 정확하고 효율적인 지원이 가능합니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 진행 중 문제가 발생하면 어떻게 해야 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left">
									프로젝트 수행 과정에서 발생하는 모든 이슈는 그레이트 프로 전담 매니저에게 연락주시면 됩니다. 매니저가 상황을 파악하여 신속한 해결 방안을 제시하고, 필요시 추가 지원이나 조치를 취합니다.<br />
									원활한 문제 해결을 위해 관련 상황을 구체적으로 공유해주시면 더욱 효과적인 지원이 가능합니다.
								</p>
							</div>
							<!--//08 프로젝트 진행관리 -->

							<!--09 프로젝트 종료 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '8'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 종료에 따른 조치사항이 별도로 있나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									계약 조건에 따라 프로젝트가 정상 완료되는 경우, 별도의 종료 절차는 필요하지 않습니다.<br/>다만, 프로젝트 기간이 변경된 경우에는 다음 절차를 준수해주시기 바랍니다.<br/>
									<br/>
									1. 프로젝트 관리 화면에서 종료일을 수정<br/>
									2. 변경된 일정을 그레이트프로 전담 매니저에게 공유<br/>
									<br/>
									상기 절차를 통해 정확한 프로젝트 수행 이력과 성과 평가 자료가 체계적으로 관리되며, 향후 프로젝트 진행 시 참고 자료로 활용됩니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">동일한 IT프로의 지속 참여가 필요한 경우 어떻게 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left">
									전담 매니저에게 재계약 의사를 전달해주시면 됩니다.<br/>
									해당 IT프로의 일정과 가능 여부를 확인한 후, 특별한 문제가 없다면 신규 계약서 작성을 통해 신속하게 협업을 지속할 수 있습니다. 기존 프로젝트에서 검증된 인재와의 연속성 있는 협업이 가능합니다.
								</p>
							</div>
							<!--//09 프로젝트 종료 -->

							<!--10 IT프로 수행 평가 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '9'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트에 참여한 IT 프로에 대한 수행 성과평가는 어떻게 해야 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									IT프로의 프로젝트 참여가 종료되면 성과 평가를 실시할 수 있습니다.<br/>
									클라이언트가 남겨주신 평가는 해당 IT프로의 성과 기록에 반영되어 향후 모든 클라이언트의 프로젝트 인재 선정 시 중요한 참고 자료로 활용됩니다.<br/>
									정확한 평가를 통해 모든 클라이언트가 검증된 적합한 인재를 선택할 수 있는 환경을 함께 만들어갈 수 있습니다.<br/>
									<br/>
									<span class="faqBold">평가 방법</span><br/>
									1. '마이페이지 > 프로젝트 관리 현황 > 미평가 IT프로' 에서 참여가 종료된 IT프로가 있는 프로젝트 확인<br/>
									2. 해당 프로젝트의 '참여 IT프로 보기'를 선택한 후 '평가하기'를 클릭하여 진행합니다.<br/>
									3. 업무실적, 근무태도, 기술능력을 각각 평가하고 종합 의견을 작성해주시면 됩니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">평가 결과를 IT프로 본인이 확인할 수 있나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									IT프로는 자신에 대한 평가 결과를 제한적으로 확인할 수 있습니다.<br/>
									업무실적, 근무태도, 기술능력에 대한 평가 결과는 시각적 등급 지표로만 공개되며, 평가자 정보나 상세 항목별 득점, 구체적인 검토 의견은 공개되지 않습니다.<br/>
									이를 통해 IT프로는 자신의 프로젝트 수행에 대한 전반적인 평가 수준을 확인하고 향후 업무 개선에 참고할 수 있습니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">평가는 언제까지 완료해야 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									프로젝트 완전 종료 후 <span class="faqBold">일주일 이내</span>에 평가를 완료하시기를 권장합니다.<br/>
									프로젝트 종료 후 한 달까지는 참여 IT프로의 세부 정보를 정상적으로 확인하실 수 있으나, 그 이후에는 시스템상 정보 확인이 제한되어 해당 인재를 정확히 파악하기 어려울 수 있습니다.<br/>
									정확하고 객관적인 평가를 위해 프로젝트 수행 과정을 명확히 파악할 수 있는 기간 내에 평가를 완료해주시기 바랍니다.<br/>
								</p>
							</div>
							<!--//10 IT프로 수행 평가 -->

							<!--11 회원 탈퇴 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '10'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">기업회원 탈퇴는 어떻게 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									내 계정관리'에서 '회원탈퇴'를 선택한 후 비밀번호를 재입력하여 탈퇴를 신청하실 수 있습니다.<br/>
									<br/>
									<span class="faqBold">탈퇴 시 처리 사항</span><br/>
									- 모든 서비스 이용 정보와 활동 내역이 완전히 삭제되며, 재가입하더라도 이전 정보를 복구 또는 승계가 불가능하므로 유의하시기 바랍니다.<br/>
									- 진행 중인 프로젝트가 있는 경우 반드시 프로젝트 종료 후 탈퇴해야 하므로, 그레이트 프로에 상담 문의를 통해 안내받으시기 바랍니다.<br/>
									<br/>
									<span class="faqBold">주의사항</span><br/>
									탈퇴 처리는 되돌릴 수 없으므로 신중하게 결정해주시기 바랍니다.
								</p>
							</div>
							<!--//11 회원 탈퇴 -->
						</div>
					</div>

					<!-- IT프로 -->
					<div class="tab_cont" :class="tabIdx == '1' ? 'active' : ''">
						<div class="tab_cont_inner">
							<div class="cont_nav">
								<ul class="cont_nav_list">
									<li v-for="(item, index) in tecItemList" :key="index" :class="itemIdx == index ? 'active' : ''">
										<a @click="itemIdxCng(index)">{{item}}</a>
									</li>
								</ul>
							</div>

							

							<!--01 회원가입 -->
							<div class="cont_detail pl-10" v-if="itemIdx == '0'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">그레이트 프로에서 'IT프로'는 누구를 지칭하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									그레이트 프로에서 IT프로는 4단계 검증을 통과한 <span class="faqBold">금융 IT분야 전문 인재를 지칭</span>합니다.<br />
									단순한 인력 공급이 아닌 검증된 전문성을 바탕으로 기업과 파트너십을 맺고 함께 성장하는 IT 전문가들을<br />의미합니다.<br />
									<br />
									그레이트프로는 모든 IT 전문가를 존중받을 만한 가치를 지닌 프로페셔널로 인정하며, 이러한 철학을 담아<br />"IT프로"라는 용어를 사용하고 있습니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">IT 프로 회원은 누구나 가입할 수 있나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									네, 금융 IT 분야에 전문성을 갖추거나 관심이 있는 모든 분께 열려있습니다.<br />
									그레이트프로는 14년간 300건 이상의 금융권 프로젝트 경험을 바탕으로 금융권 특화 프리미엄 매칭 서비스를 제공하고 있습니다.<br />
									가입 후 프로젝트 참여를 위해서는 이력서, 경력증명서 등 기술 등급 산정 자료 등록이 필요하며,<br />4단계 검증 과정을 통해 IT 분야 전문성을 확인받으시면 검증된 금융 IT 프로젝트에 참여하실 수 있습니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">IT프로 회원가입 시 어떤 혜택이 있나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									회원가입 후 단계별로 다양한 혜택을 받으실 수 있습니다.<br />
									<br />
									<span class="faqBold">가입 즉시:</span> 전담 커리어 매니저(CM) 배정 및 1:1 이력서 코칭 지원<br />
									<span class="faqBold">프로필 완성:</span> 포인트 지급 및 기술경력 인증서 제공<br />
									<span class="faqBold">프로젝트 성공:</span> 성공 보상금 포인트 지급 (등급별 차등)<br />
									<br />
									모든 포인트는 프로젝트 완수 후 현금으로 지급되며, 별도의 플랫폼 이용 수수료는 없습니다.<br />
									상세한 포인트 지급 조건과 금액은 '포인트' 섹션에서 확인하실 수 있습니다.
								</p>
							</div>
							<!--//01 회원가입 -->

							<!--02 IT프로 경력관리 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '1'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">그레이트 프로는 IT프로의 경력 관리를 어떻게 지원하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									그레이트 프로는 IT프로의 <span class="faqBold">경력과 삶 전체를 설계하는 파트너</span>를 목표로 합니다.<br />
									<br />
									<span class="faqBold">프로필 완성 지원:</span> 이력서 등록 대행 서비스와 커리어 매니저의 1:1 코칭을 제공합니다. IT프로의 경력 정보는 기술 등급 산정과 프로젝트 매칭의 핵심 기준이 되므로, 정확한 프로필 관리가 성공적인 프로젝트 참여의 출발점이 됩니다.<br />
									<span class="faqBold">전담 매니저 시스템:</span> 각 IT프로에게 커리어 매니저가 배정되어 프로젝트 매칭 전 역량 파악부터 프로젝트 완료 후 다음 기회 연계까지 장기적인 커리어 동반자 역할을 수행합니다.<br />
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">기술 등급 평가는 무엇인가요? 왜 필요한가요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									기술 등급 평가는 그레이트프로의 4단계 검증 시스템을 통해 IT프로의 전문성을 객관적으로 확인하고 평가하는 과정의 일부입니다.IT프로에게는 역량에 맞는 적정한 프로젝트와 보상을, 기업에게는 검증된 전문 인재를 연결하여 신뢰할 수 있는 프로젝트 매칭을 실현합니다.<br />
									IT프로에 대한 전체 평가 검증은 객관적 정량 평가, 전담 매니저의 정밀 진단, 프로젝트 수행 중 다면 평가, 스페셜 등급 부여의 4단계로 진행됩니다. 기술등급은 이력서 내용을 바탕으로 학력·자격·경력 기반 객관적 정량 평가를 실시하고, 전담 매니저의 정밀 진단을 통해 검증하여 부여됩니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">기술력 평가를 위하여 어떤 증빙서류를 제출하여야 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									프로젝트 지원을 위해서는 다음 자료를 등록하여 기술 등급을 확정해야 합니다<br />
									<br />
									<span class="faqBold">등록대상 정보:</span> 이력서, 경력, 학력, 자격, 수상경력 등<br />
									<span class="faqBold">증빙서류 등록:</span> KOSA증빙, 건강보험자격득실확인서, 졸업증명서, 자격증취득확인서, 기술경력증명서<br />
									<br />
									제출된 자료를 바탕으로 전담 매니저가 정밀 진단을 실시하며, 등급 산정이 완료되면 문자 또는 카카오 알림톡을 통해 결과를 안내해드립니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">소속사 등록은 어떻게 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									프로젝트 지원을 위해서는 <span class="faqBold">소속사 설정</span>이 필수입니다. 마이페이지의 '내 소속사 관리'에서 설정할 수 있습니다.<br />
									<br />
									<span class="faqBold">개인 프리랜서:</span> '소속사 없음'으로 설정하면 바로 프로젝트 지원이 가능합니다.<br />
									<span class="faqBold">회사 소속 프리랜서(반프리):</span> 현재 소속사를 등록해야 하며, 해당 회사가 그레이트프로 파트너사로 등록되어 있지 않은 경우 사전에 파트너사 가입 절차가 필요할 수 있습니다. 소속사와의 업무 협약 관련 사항은 개별적으로 확인이 필요하므로 담당 매니저와 상담받으시기 바랍니다.<br />
									<br />
									구체적인 상황에 따른 절차는 전담 매니저가 안내해드립니다.
								</p>
							</div>
							<!--//02 IT프로 경력관리 -->

							<!--03 프로젝트 지원 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '2'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 지원은 누구나 할 수 있나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									소속사 등록과 기술 등급이 확정된 IT프로는 누구나 그레이트프로의 금융 IT 프로젝트에 지원할 수 있습니다. 다만 프로젝트별로 요구되는 기술 스택, 경력 수준, 전문 분야가 다르므로, 개별 프로젝트의 지원 조건을 확인 후 지원하시기 바랍니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 매칭 과정은 어떻게 되나요?</strong>
								</div>
								<p class="text_type_01 ta-left">
									프로젝트 지원 후 전담 매니저가 귀하의 프로필과 프로젝트 요구사항을 검토하여 적합성을 판단합니다.<br />
									선별된 경우 클라이언트에게 추천되며, 클라이언트가 인터뷰를 요청하면 전담 매니저가 일정을 조율하여 안내해드립니다.
									또한 클라이언트가 직접 귀하의 프로필을 보고 인터뷰를 요청하는 경우도 있으며, 모든 과정에서 전담 매니저가 지원합니다. 상세한 인터뷰 절차는 인터뷰 섹션에서 확인하실 수 있습니다.
								</p>
							</div>
							<!--//03 프로젝트 지원 -->

							<!--04 인터뷰 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '3'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">인터뷰는 어떻게 진행되나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									인터뷰는 IT프로와 클라이언트가 프로젝트 요구사항과 수행 역량을 상호 확인하는 과정입니다. 대면 또는 비대면으로 진행되며, 필요시 3자 인터뷰를 통해 적합성을 최종 확인합니다. 전담 매니저가 일정 조율부터 결과 전달까지 전 과정을 지원하며, 진행 상황은 플랫폼에서 실시간 확인 가능합니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">인터뷰 요청은 어떤 방식으로 이루어지나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									두 가지 방식으로 진행됩니다. IT프로가 먼저 지원한 경우 전담 매니저가 검토 후 클라이언트에게 추천하고,<br />클라이언트가 선택하여 인터뷰를 요청합니다. 클라이언트가 직접 IT프로를 검색하여 인터뷰를 요청하는 경우에는 간단한 검토 후 바로 진행됩니다. 
									두 방식 모두 전담 매니저가 전 과정을 관리하여 원활한 인터뷰가 이루어지도록 지원합니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">인터뷰 결과는 어떻게 확인할 수 있나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									‘내 프로젝트 > 내 인터뷰’ 화면에서 확인할 수 있으며, 결과가 등록시 알림 메시지로 자동 안내됩니다.<br />
									합격하신 경우, 전담 매니저가 직접 연락드려 참여 일정 및 후속 절차를 상세히 안내해드립니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">인터뷰 합격 후 참여가 어려운 경우 어떻게 해야 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									부득이한 사정으로 프로젝트 참여가 어려운 경우 그레이트프로 전담 매니저에게 즉시 연락하여 상황을 설명해주시기 바랍니다. 매니저가 클라이언트에게 신속히 안내하고 대안을 모색해드립니다. 다만 참여 의사 번복이<br />빈번할 경우 향후 프로젝트 매칭에 영향을 줄 수 있으므로 신중한 지원을 부탁드립니다.
								</p>
							</div>
							<!--//04 인터뷰 -->

							<!--05 계약 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '4'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 참여에 대한 계약은 어떻게 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									프로젝트 참여가 확정되면 그레이트프로 전담 매니저와 협의하여 계약을 진행합니다. 그레이트프로가 계약의 주체가 되어 IT프로와 직접 계약을 체결하며, 매니저가 계약서 작성부터 조건 협의까지 전 과정을 지원합니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 수행 도중 계약을 변경해야 할 경우 어떻게 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									프로젝트 담당매니저와 협의하시면 됩니다.<br />
									필요한 경우 변경계약서 또는 추가계약서 등 조치방법을 알려드립니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 대금은 어떻게 받나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									그레이트프로가 클라이언트로부터 대금을 직접 수령한 후, 계약 조건에 따라 IT프로에게 지급합니다.<br />
									그레이트프로는 검증된 기업과만 협업하며 계약 당사자로서 대금 지급 책임을 지므로, 지급 지연이나 체불 등의 리스크 없이 안심하고 프로젝트에 집중하실 수 있습니다. 11년간 분쟁률 0%를 기록하며 대금 지급의 신뢰성을 입증하고 있습니다.
								</p>
							</div>
							<!--//05 계약 -->

							<!--06 프로젝트 수행 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '5'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 참여 전 준비사항은 무엇인가요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									프로젝트 전담 매니저(PM)가 프로젝트 개요와 사이트 업무 지침을 안내해드립니다. 담당 업무에 필요한 기술 스택과 업무 지식을 사전에 검토하여 수행 가능 여부를 확인해주시기 바랍니다.<br />
									<br />
									검토 결과 수행이 어려운 업무가 있다면 프로젝트 매니저에게 미리 알려주시기 바랍니다. 그레이트프로에서는 필요시 역량 강화 상담과 금융 업무 사전 교육을 지원하여 성공적인 프로젝트 시작을 돕습니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 수행 중 어떤 지원을 받을 수 있나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									프로젝트 전담 매니저(PM)와 커리어 매니저(CM)가 전 과정에서 지원합니다. 정기적인 진행 상황 점검과 애로사항 상담을 제공하며, 커뮤니티 참여와 건강검진, 심리 상담 등 라이프케어 지원도 받으실 수 있습니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 진행상황을 매니저에게 보고해야 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									IT프로는 프로젝트 관련 주요 이슈나 진행 사항을 담당 매니저와 공유해주시면, 매니저가 필요한 지원과 조치를 신속히 제공하여 성공적인 프로젝트 완수를 돕습니다.<br />
									정기적인 소통을 통해 문제를 사전에 예방하고 최적의 성과를 달성할 수 있도록 지원합니다.
								</p>
							</div>
							<!--//06 프로젝트 수행 -->

							<!--07 프로젝트 종료 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '6'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 종료는 어떤 순서로 진행되나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									프로젝트 종료 확정 시 전담 매니저에게 철수 일정을 알려주시기 바랍니다. 할당된 업무를 완료한 후 클라이언트와 인수인계 및 최종 승인 절차를 거쳐 프로젝트를 마무리합니다.<br />
									종료 후에는 이력 정보를 업데이트하고, 클라이언트와 그레이트프로의 평가를 받게 됩니다. 이 평가는 향후 스페셜 등급 관리와 프로젝트 매칭에 반영됩니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트를 성공적으로 마무리하려면 어떻게 해야 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									할당된 프로젝트 과제를 계획대로 완료한 후 해당 결과에 대한 인수인계와 클라이언트의 최종 승인을 받아야 합니다. 검수 완료 후에 프로젝트 철수가 가능합니다.<br />
									클라이언트가 산출물을 승인하지 않을 경우 계약 이행에 문제가 생길 수 있으므로, 품질 기준에 맞는 철저한 마무리가 필요합니다. 성공적인 프로젝트 완수는 향후 평가와 다음 기회 연계에도 중요한 요소가 됩니다.<br />
									공식적인 인수인계 및 승인 절차가 필요하지 않은 경우에는 클라이언트 및 프로젝트 리더의 철수 절차에 따라 진행하시면 됩니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">다음 프로젝트는 어떻게 찾나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									지속적인 프로젝트 참여를 희망하시는 경우 마이페이지의 '프로젝트 참여 설정'을 활성화해 두시기 바랍니다. 클라이언트와 커리어 매니저가 귀하의 참여 가능 상태를 확인하여 적합한 신규 프로젝트를 추천합니다.
								</p>
							</div>
							<!--//07 프로젝트 종료 -->

							<!--08 회원 탈퇴 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '7'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">그레이트 프로 회원을 탈퇴하려면 어떻게 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									마이페이지의 정보수정하기에서 회원탈퇴를 선택한 후 비밀번호를 재입력하여 신청하실 수 있습니다. 탈퇴 시 등록된 프로젝트 정보와 적립금이 삭제되며 복구가 어려우니 신중하게 결정해주시기 바랍니다. 진행 중인 프로젝트가 있는 경우 사전에 담당 매니저와 협의가 필요합니다.<br />
									<br />
									탈퇴로 인한 프로젝트 차질이나 기타 불이익에 대한 책임은 회원 본인에게 있으므로 신중하게 결정해주시기 바랍니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">탈퇴한 회원이 재가입하려면 어떻게 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									네, 재가입이 가능합니다.<br />
									신규 회원과 동일하게 약관 동의, 본인 인증, 회원정보 입력, 이력정보 및 증빙서류 등록 과정을 거쳐 서비스를 이용하실 수 있습니다.
									재가입 시 기존 이력과 평가 정보는 복원되지 않으므로 새로운 기술 등급 평가를 받아야 합니다. 다만 반복적인 가입과 탈퇴는 서비스 이용에 제한이 있을 수 있으므로 유의하시기 바랍니다.
								</p>
							</div>
							<!--//08 회원 탈뢰 -->
						</div>
					</div>

					<!-- 공급기업 -->
					<div class="tab_cont" :class="tabIdx == '3' ? 'active' : ''">
						<div class="tab_cont_inner">
							<div class="cont_nav">
								<ul class="cont_nav_list">
									<li v-for="(item, index) in scoItemList" :key="index" :class="itemIdx == index ? 'active' : ''">
										<a @click="itemIdxCng(index)">{{item}}</a>
									</li>
								</ul>
							</div>							

							<!--01 회원가입 -->
							<div class="cont_detail pl-10" v-if="itemIdx == '0'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">그레이트 프로에서 파트너사란 무엇인가요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									파트너사는 그레이트 프로와 전략적 협력 관계를 맺고 소속 IT전문인력을 금융권 프로젝트에 공급하는 전문 기업입니다.<br/>
									파트너사는 그레이트 프로의 검증된 수요기업 네트워크를 통해 안정적인 프로젝트 기회를 확보할 수 있으며, 영업 및 프로젝트 관리 부담 없이 핵심 역량인 인력 공급과 기술 수행에만 집중할 수 있습니다.<br/>
									그레이트프로는 파트너사를 일시적인 협력사가 아닌 공동 성장하는 신뢰 기반의 비즈니스 파트너로 인식하며, 상호 이익을 추구하는 장기적 협력 관계를 지향합니다.
								</p>

								<div class="ta-left mb-4 text_type_title">
									그레이트 프로 서비스는 어떻게 이용할 수 있나요?<br />
									<!-- <span>(그레이트 프로 서비스 이용계약 체결)</span> -->
								</div>
								<p class="text_type_01 ta-left mb-16">
									그레이트프로와 파트너사 간 '서비스 이용계약' 체결이 선행되어야 합니다.<br/>
									<br/>
									<span class="faqBold">계약 절차</span><br/>
									1. 별도 계약서를 통한 서비스 이용계약 체결<br/>
									2. 그레이트 프로 운영팀에서 제공받은 기업정보를 시스템 등록<br/>
									3. 파트너사 실무담당자의 개인명의 회원가입 진행<br/>
									<span class="faqBold">계약 문의 방법</span><br/>
									파트너사 서비스 이용계약 체결을 원하시는 기업은 사이트 하단의 '문의하기' 또는 챗봇을 통해 문의를 남겨주시면 담당자가 상세한 절차와 조건을 안내해드립니다.
								</p>
							</div>
							<!--//01 회원가입 -->

							<!--02 소속사 인력현황 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '1'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">소속 IT프로에 대한 어떤 정보를 확인할 수 있나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									그레이트 프로에 회원으로 등록된 소속 IT프로의 상세 정보를 종합적으로 조회할 수 있습니다.<br/>
									이력 정보, 기술 등급, 평가 결과 등 프로젝트 매칭에 필요한 모든 정보가 체계적으로 관리되어 파트너사의 효율적인 인력 관리를 지원합니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트에 지원한 IT프로는 어떻게 확인할 수 있나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									우측 상단의 인물아이콘을 클릭한 후 '마이페이지 &gt; 프로젝트'에서  소속 IT프로의 프로젝트 지원 현황을 실시간으로 확인할 수 있습니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">소속 IT프로의 프로젝트 지원 및 인터뷰 관리는 어떻게 진행되나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									소속 IT프로가 그레이트 프로를 통해 프로젝트에 지원하면 파트너사와 사전 협의가 완료된 것으로 간주됩니다.<br/>
									그레이트 프로 전담 매니저가 인터뷰 진행을 지원하며, 파트너사는 그레이트프로와 공급계약을 체결하시면 됩니다. 이를 통해 파트너사는 별도의 영업 활동 없이도 안정적인 프로젝트 참여 기회를 확보할 수 있습니다.
								</p>

							</div>
							<!--//02 소속사 인력현황 -->

							<!--03 계약 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '2'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트에 참여한 IT 프로와 관련한 계약은 어떻게 하나요? </strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									프로젝트 참여가 확정되면 그레이트 프로와 파트너사 간에 공급계약을 체결합니다.<br/>
									그레이트 프로 전담 매니저가 계약서 작성부터 조건 협의까지 전 과정을 담당합니다.<br/>별도의 온라인 계약 시스템은 제공하지 않으며, 매니저와의 협의를 통해 계약을 진행합니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 수행 도중 계약을 변경해야 할 경우 어떻게 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									그레이트 프로 전담 매니저와 협의하시면 됩니다.<br/>
									프로젝트 범위, 기간, 인력 구성 등의 변경이 필요한 경우 매니저가 변경계약서 또는 추가계약서 등 적절한 조치 방법을 안내해드립니다.
								</p>

								<div class="ta-left mb-4">
									<strong class="text_type_title">계약 및 대금 지급은 어떻게 처리되나요?</strong>
								</div>
								<p class="text_type_01 ta-left">
									모든 계약 업무는 그레이트 프로 본사에서 직접 처리하며, 필요시 프로젝트 전담 매니저에게 실무를 위임하여 진행합니다.
								</p>
							</div>
							<!--//03 계약 -->

							<!--04 프로젝트 진행관리 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '3'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">프로젝트 진행 중 파트너사가 받을 수 있는 지원은 무엇인가요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									그레이트프로는 파트너사 소속 IT프로의 원활한 프로젝트 수행을 위해 다음과 같은 관리 지원을 제공합니다.<br/>
									<br/>
									<span class="faqBold">전담 관리 지원:</span> 프로젝트 담당 매니저가 지정되어 투입된 IT프로의 전반적인 관리 업무를 담당합니다.<br/>
									<span class="faqBold">사전 준비 지원:</span> 해당 수요기업의 근무 환경에 맞는 사전 교육을 실시하여 근무 규정, 보안 수칙, 휴가 절차 등을 안내합니다.<br/>
									<span class="faqBold">지속적인 성과 모니터링:</span> 담당 역할에 대한 수행 상황을 정기적으로 확인하며, 업무 수행에 어려움이 있을 경우 개선 방안을 지원합니다. 또한 팀워크 향상과 원활한 협업을 위한 현장 모니터링을 진행합니다.
								</p>
							</div>
							<!--//04 프로젝트 진행관리 -->

							<!--05 회원 탈퇴 -->
							<div class="cont_detail pl-10" v-else-if="itemIdx == '4'">
								<div class="ta-left mb-4">
									<strong class="text_type_title">기업회원이 탈퇴하려면 어떻게 하나요?</strong>
								</div>
								<p class="text_type_01 ta-left mb-16">
									내 계정관리'에서 '회원탈퇴'를 선택한 후 비밀번호를 재입력하여 탈퇴를 신청하실 수 있습니다.<br/>
									<br/>
									<span class="faqBold">탈퇴 시 처리 사항</span><br/>
									- 모든 서비스 이용 정보와 활동 내역이 완전히 삭제되며, 재가입하더라도 이전 정보를 복구 또는 승계가 불가능하므로 유의하시기 바랍니다<br/>
									- 프로젝트에 참여중인 소속 IT프로가 있는 경우 반드시 프로젝트 종료 후 탈퇴해야 하므로, 그레이트 프로에 상담 문의를 통해 안내받으시기 바랍니다<br/>
									<br/>
									<span class="faqBold">주의사항</span><br/>
									탈퇴 처리는 되돌릴 수 없으므로 신중하게 결정해주시기 바랍니다.
								</p>
							</div>
							<!--//05 회원 탈퇴 -->
						</div>
					</div>

					<!-- 이용요금 -->
					<div class="tab_cont" :class="tabIdx == '4' ? 'active' : ''">
						<div class="tab_cont_inner">
							<div class="ta-left mb-4">
								<strong class="text_type_title">그레이트 프로 인력공급 계약</strong>
							</div>
							<div class="tbl-view">
								<table>
									<colgroup>
										<col width="130" />
										<col width="130" />
										<col width="160" />
										<col width="95" />
										<col width="*" />
										<col width="75" />
										<col width="75" />
									</colgroup>
									<thead>
										<tr>
											<th rowspan="2">구분</th>
											<th rowspan="2">계약형태</th>
											<th rowspan="2">계약내용</th>
											<th rowspan="2">계약주체</th>
											<th rowspan="2">계약금액</th>
											<th rowspan="2">결제단위</th>
											<th rowspan="2">결제시기</th>
										</tr>	
									</thead>
									<tbody>
										<tr>
											<td rowspan="6">
												구인계약<br />
												(인력용역)    
                                            </td>	
											<td rowspan="3">
												프로젝트 외주<br />(도급)
											</td>
											<td rowspan="3">
												프로젝트 단위<br />개발 계약
											</td>
											<td>클라이언트</td>
											<td>프로젝트대금</td>
											<td>건별</td>
											<td>후지급</td>			
										</tr>
										<tr>
											<td>파트너사</td>
											<td>별도 협의 후 계약</td>	
											<td>건별</td>
											<td>후지급</td>	
										</tr>	
										<tr>
											<td>IT프로</td>
											<td>별도 협의 후 계약</td>
											<td>건별</td>
											<td>후지급</td>		
										</tr>
										<tr>
											<td rowspan="3">
												인력단위<br /> 용역계약<br />
												(기간제 상주)
											</td>
											<td rowspan="3">
												개인별 프로젝트<br />
												개발용역 계약
											</td>
											<td>클라이언트</td>
											<td>용역대금</td>
											<td>건별</td>
											<td>후지급</td>
										</tr>	
										<tr>
											<td>파트너사</td>
											<td>별도 협의 후 계약</td>	
											<td>건별</td>
											<td>후지급</td>
										</tr>
										<tr>
											<td>IT프로</td>	
											<td>급여<br />
												<span>(4대보험 또는 원천징수 3.3% 포함)</span>
											</td>
											<td>건별</td>
											<td>후지급</td>
										</tr>		
									</tbody>		
								</table>
							</div>
							<p class="text_type_as ta-left"><br>
								※ 계약금액에 부가세는 별도 부과됩니다.<br><br>
						    </p>
							<br />
							<br />
							<br />

							<div class="ta-left mb-4">
								<strong class="text_type_title">그레이트 프로 서비스 이용요금</strong>
							</div>
							<div class="tbl-view">
								<table>
									<colgroup>
										<col width="130" />
										<col width="130" />
										<col width="160" />
										<col width="95" />
										<col width="*" />
										<col width="75" />
										<col width="75" />
									</colgroup>
									<thead>
										<tr>
											<th rowspan="2">구분</th>
											<th rowspan="2">계약형태</th>
											<th rowspan="2">계약내용</th>
											<th rowspan="2">계약주체</th>
											<th rowspan="2">계약금액</th>
											<th rowspan="2">결제단위</th>
											<th rowspan="2">결제시기</th>
										</tr>	
									</thead>
									<tbody>
										<tr>
											<td rowspan="2">
												그레이트 프로<br />서비스  
												사용 계약
                                            </td>	
											<td rowspan="2">
												서비스<br />사용 계약
											</td>
											<td rowspan="1">
												프로젝트 관련<br />   
												인력 소싱을 위한<br />   
                                                지원 서비스 계약
											</td>
											<td>클라이언트</td>
											<!-- <td>2만원<br />   * 인터뷰, 투입준비 등 지원 수수료</td> -->
											<td>별도 협의</td>
											<!-- <td>건별</td> -->
											<!-- <td>후납</td>			 -->
											<td>-</td>
											<td>-</td>
										</tr>
										<tr>
											<td rowspan="1">
												외주인력<br />서류관리시스템<br />   
                                                사용 계약
											</td>
											<td>클라이언트</td>
											<!-- <td>그레이트 프로 시스템 연간 이용수수료<br />   
                                                (기본요금 3천만원,  1,000명까지 기본요금,<br />    
                                                 1,000명 초과시 100명 단위 1백만원씩 추가) <br />   
                                                * 상세요금은 계약 시 별도 협의</td>	 -->
											<td>별도 협의</td>
											<!-- <td>1년</td> -->
											<!-- <td>선납<br />(기본요금)<br /> 후납<br />(추가분)</td>	 -->
											<td>-</td>
											<td>-</td>
										</tr>	
												
									</tbody>
											
								</table>
							</div>
						</div>
					</div>

					<!-- 포인트 제도 -->
					<div class="tab_cont" :class="tabIdx == '5' ? 'active' : ''">
						<div class="tab_cont_inner">
							<div class="ta-left mb-4">
								<strong class="text_type_title">그레이트 프로의 포인트 제도 및 현금 지급</strong>
							</div>
							<!-- <div style="text-align: center; padding: 100px 0; font-size: 26px; font-weight: bold;">서비스 준비중입니다.</div> -->
							<div class="tbl-view type2">
								<table>
									<colgroup>
										<col width="120" />
										<col width="150" />
										<col width="120" />
										<col width="280" />
										<col width="*" />
									</colgroup>
									<thead>
										<tr>
											<th>구분</th>
											<th>포인트 획득 조건</th>
											<th>지급 포인트</th>
											<th>포인트 지급 대상 회원</th>
											<th>포인트 현금 지급 시기</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td rowspan="4">IT 프로</td>
											<td>프로필 완성</td>
											<td>200,000 P</td>
											<td>프로필 기술등급 확정 프로 회원</td>
											<td rowspan="4">
												프로젝트 종료 및 <br />
												클라이언트 평가 완료 후 <br />
												적립포인트 일괄 지급
											</td>
										</tr>
										<tr>
											<td>인터뷰 완료</td>
											<td colspan="2">현장 인터뷰 참여비 10만원 지급</td>
										</tr>
										<tr>
											<td rowspan="2">프로젝트 완수</td>
											<td>300,000 P</td>
											<td>일반 IT 프로 회원</td>
										</tr>	
										<tr>											
											<td>800,000 P</td>
											<td>스페셜 IT 프로 회원</td>
										</tr>									
									</tbody>
								</table>						
							</div>
							<p class="text_type_as ta-left">
								※ 회원에 대한 지급포인트의 적정여부는 그레이트 프로에서 최종 확인합니다.<br />
								※ 포인트의 현금보상은 회원관리팀에서 최종 확인한 시점의 월말로 합니다. 
						    </p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { howtouseMeta } from '@/utils/meta';
import { itproGuideMeta } from '@/utils/meta';
import { clientGuideMeta } from '@/utils/meta';
import { vendorGuideMeta } from '@/utils/meta';
import { pricingMeta } from '@/utils/meta';
import { pointMeta } from '@/utils/meta';

export default {
	data() {
		return {
			tabIdx : '5',
			itemIdx : '0',
			faqTabList : [
				'서비스 안내',
				'IT프로',
				'클라이언트',				
				'파트너사',
				'이용요금',
				'포인트'
			],
			dcoItemList : [
				'01 회원가입',
				'02 프로젝트 등록',
				'03 IT프로 찾기',
				'04 프로젝트 지원인재',
				'05 관심인재 등록',
				'06 IT프로 인터뷰',
				'07 계약',
				'08 프로젝트 진행관리',
				'09 프로젝트 종료',
				'10 IT프로 수행 평가',
				'11 회원 탈퇴'
			],
			tecItemList : [
				'01 회원가입',
				'02 프로필관리',
				'03 프로젝트 지원',
				'04 인터뷰',
				'05 계약',
				'06 프로젝트 수행',
				'07 프로젝트 종료',
				'08 회원 탈퇴'
			],
			scoItemList : [
				'01 회원가입',
				'02 소속사 인력현황',
				'03 계약',
				'04 프로젝트 진행관리',
				'05 회원 탈퇴'
			],

			metaData: ''
		}
	},

	beforeMount() {
		var viewNm = this.$route.name;

		/* 탭 변경 */
		switch (viewNm) {
			case 'FAQ002M01':
				this.tabIdx = '1';
				this.metaData = itproGuideMeta;
				break;
			
			case 'FAQ003M01':
				this.tabIdx = '2';
				this.metaData = clientGuideMeta;
				break;
			
			case 'FAQ004M01':
				this.tabIdx = '3';
				this.metaData = vendorGuideMeta;
				break;
			
			case 'FAQ005M01':
				this.tabIdx = '4';
				this.metaData = pricingMeta;
				break;

			case 'FAQ006M01':
				this.tabIdx = '5';
				this.metaData = pointMeta;
				break;
		
			default:
				this.tabIdx = '0';
				this.metaData = howtouseMeta;
				break;
		}

	},

	created() {
		// document.title = "그레이트 프로 FAQ"
	},

	methods: {
		tabIdxCng(idx) {
			this.$router.move('FAQ00'+(idx+1)+'M01');
			//this.tabIdx = idx;
			//this.itemIdx = '0';
		},

		itemIdxCng(idx) {
			this.itemIdx = idx;
		}
	},

	metaInfo() {
		return this.metaData;
	},
}
</script>
<style>
  .faqBold {font-weight:Bold;}
</style>